import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  header: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#000000',
    padding: '10px 12px 10px 20px',
  },
  activeButton: {
    fontType: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    width: '95px',
    height: '30px',
    lineHeight: '22px',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#266733',
    },
    backgroundColor: '#347F42',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    alignItems: 'center',
  },
}));
